<template>
	<BaseModal v-model="showLoginModal" :disableClose="true" :bodyHeightAuto="true" size="500px" :noPadding="true" :rounded="true">
		<template v-slot:header>
			<div class="text-center modal-message-text">
				Please log in to continue.
			</div>
		</template>
		<template v-slot:body>
			<div class="d-flex justify-content-center buttons-container">
				<BaseButton style="font-size:1rem;" @click="redirectToLogin" class="mb-0 border-0">LOGIN</BaseButton>
				<BaseButton style="font-size:1rem;" @click="hideLoginModal" class="ml-2 mb-0 border-0">CANCEL</BaseButton>
			</div>
		</template>
	</BaseModal>
</template>

<script>
	import BaseModal from './BaseModal';
	import { mapState } from 'vuex';
	import {PROFILE_CONSTANTS} from '@/PROFILE_CONSTANTS';

	export default {
		name: "LoginToContinueModal",
		components: {
			BaseModal
		},
		props: {
			redirectOnCancel: {
				type: String,
				default: null
			}
		},
		computed: {
			...mapState({
				showLoginModal: state => state.showLoginModal,
			}),
		},
		methods: {
			hideLoginModal() {
				this.$store.commit("updateLoginModalVisibility", false);
				if(this.redirectOnCancel) {
					window.location.href = this.redirectOnCancel;
				} else {
					window.location.reload();
				}
			},
			redirectToLogin () {
				$cookies.set(
					'au_loginredirect',
					window.location.pathname,
					60 * 60 * 3,
					null,
					null,
					true
				);
				window.location.href = PROFILE_CONSTANTS.LOGIN_REDIRECT;
			}
		}
	}
</script>
<style lang="scss" scoped>
	.modal-message-text {
		font-size: 1.125rem;
		padding:15px;
	}
	.buttons-container {
		padding:0.75rem;
		border-top: 1px solid #dee2e6;
	}
</style>